import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'
import WarningInfo from './WarningInfo'
import {
  StyledContainer,
  StyledContentContainer,
  StyledHeaderContainer,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledIconContainer,
  StyledActionContainer,
  StyledMetadataContainer
} from './index.css'

const StyledContentInHeader = styled(StyledHeaderLeft)`
  line-height: ${sys.typescale[14].lineHeight};
  font-size: ${sys.typescale[14].size};
`

type SoundbiteNoHeaderFrameProps = {
  hasWarningInfo?: boolean
  dateItem?: React.ReactNode
  domainIcon?: React.ReactElement
  postContent?: React.ReactNode
  actionItems?: React.ReactNode
  metadataItems?: React.ReactNode
  mediaItems?: React.ReactNode
  avatar?: React.ReactNode
  photoUserTagContent?: React.ReactNode
  serialNumber: number
  onClick?: (content: any) => void
}

const SoundbiteNoHeaderFrame = ({
  dateItem,
  domainIcon,
  postContent,
  actionItems,
  metadataItems,
  mediaItems,
  avatar,
  photoUserTagContent,
  hasWarningInfo = false,
  serialNumber,
  onClick
}: SoundbiteNoHeaderFrameProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledContainer
      mode={theme}
      data-testid={`${AutomationId.soundbiteDefaultFrame.post}-${serialNumber}`}>
      {avatar}
      <StyledContentContainer onClick={onClick}>
        <StyledHeaderContainer>
          <StyledContentInHeader>{postContent}</StyledContentInHeader>
          <StyledHeaderRight
            mode={theme}
            onClick={(event) => {
              event.stopPropagation()
            }}>
            {dateItem}
            <StyledIconContainer
              onClick={(event) => {
                event.stopPropagation()
              }}>
              {domainIcon}
            </StyledIconContainer>
          </StyledHeaderRight>
        </StyledHeaderContainer>
        {photoUserTagContent}
        <StyledActionContainer
          onClick={(event) => {
            event.stopPropagation()
          }}>
          {actionItems}
        </StyledActionContainer>
        {hasWarningInfo && <WarningInfo />}
        {mediaItems}
        <StyledMetadataContainer mode={theme}>{metadataItems}</StyledMetadataContainer>
      </StyledContentContainer>
    </StyledContainer>
  )
}

export default SoundbiteNoHeaderFrame
